module.exports = __webpack_public_path__ + "static/media/gem.0ae857af.svg";